<template>
  <div class="pageMain" :class="globalDataArray.siteInfo.greyOut == 1 ? 'bigEventGray' : ''">
    <div class="banner perBan">
      <img :src="banners.image" alt="">
      <div class="w1440">
        <div class="txt">
          <p class="fnt_52">
            {{ globalDataArray.siteTemplateLanguage.banner_welcome }}
            <template v-if="saitiAccessInfo.username!=''&&saitiAccessInfo.username!=null">
              {{ saitiAccessInfo.username }}
            </template>
            <template v-else-if="saitiAccessInfo.nickname!=''&&saitiAccessInfo.nickname!=null">
              {{ saitiAccessInfo.nickname }}
            </template>
          </p>
          <span class="fnt_18 mail" v-if="saitiAccessInfo.email!=''&&saitiAccessInfo.email!=null">
            {{ saitiAccessInfo.email }}
          </span>
          <span class="fnt_18" v-else-if="saitiAccessInfo.phone!=''&&saitiAccessInfo.phone!=null">
            {{ saitiAccessInfo.phone }}
          </span>
        </div>
      </div>
    </div>

    <div class="personPage">
      <div class="cf w1440">
        <div class="personLeft">
          <personmenu />
        </div>

        <div class="personRight">
          <div class="tit fnt_32">{{ globalDataArray.siteTemplateLanguage.person_my_invitation }}</div>
          <div class="antDesignInvitation">
            <a-input :placeholder="globalDataArray.siteTemplateLanguage.anyone_competition_detail_url" style="max-width: 500px;" v-model="url"/>
            <a-button type="primary" style="margin-left:20px;" @click="generateUrl()">{{globalDataArray.siteTemplateLanguage.generate_invitation_url}}</a-button>
          </div>
          <div class="antDesignTable">
            <a-table
              row-key="id"
              :scroll="{x:true}"
              :columns="columns"
              :data-source="list"
              :pagination="paginationOpt"
              class="j-table-force-nowrap">

              <template slot="inviteUrl" slot-scope="text, record">
                  <a :href="record.inviteUrl" target="_blank" class="compNameBtn">{{record.title}}</a>
              </template>

              <template slot="sourceUrl" slot-scope="text, record">
                  <a :href="record.sourceUrl" target="_blank" class="compNameBtn">{{record.title}}</a>
              </template>
            </a-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { inviteRecord, cancelRecord, generateInvitationUrl } from '@/api/person/person'
import { getAdList } from '@/api/api'
import Cookies from 'js-cookie'
import { Modal, message } from 'ant-design-vue'
import dayjs from 'dayjs'
export default {
  name: 'MyInvitation',
  data() {
    return {
      title: this.globalDataArray.siteInfo.title,
      description: this.globalDataArray.siteInfo.description,
      keywords: this.globalDataArray.siteInfo.keywords,
      saitiAccessInfo: '',
      banners: {},
      list: [],
      paginationOpt: {
        current: 1,
        defaultCurrent: 1,
        defaultPageSize: 10,
        pageSize: 10,
        total: 0,
        hideOnSinglePage: true,
        onChange: (current, size) => {
          this.defaultPageSize = size
          this.paginationOpt.current = current
          this.inviteRecord()
        },
        // onChange:在分页数量和当前页发生变化时触发
        onShowSizeChange: (current, pageSize) => {
          this.paginationOpt.pageSize = pageSize
        }
      },
      columns: [
        {
          title: '序号',
          dataIndex: '',
          key: 'rowIndex',
          width: 80,
          align: 'center',
          customRender: (text, record, index) => {
            return ((this.paginationOpt.current - 1) * this.paginationOpt.pageSize + index + 1)
          }
        },
        {
          title: '页面URL',
          align: 'center',
          dataIndex: 'inviteUrl',
          scopedSlots: { customRender: 'inviteUrl' },
          sorter: (a, b) => a.inviteUrl.length - b.inviteUrl.length
        },
        {
          title: '原始链接',
          align: 'center',
          dataIndex: 'sourceUrl',
          scopedSlots: { customRender: 'sourceUrl' },
          sorter: (a, b) => a.sourceUrl.length - b.sourceUrl.length
        },
        {
          title: '报名团队数',
          align: 'center',
          dataIndex: 'teams',
          sorter: (a, b) => a.teams - b.teams
        },
        {
          title: '报名团队人数',
          align: 'center',
          dataIndex: 'users',
          sorter: (a, b) => a.users - b.users
        },
        {
          title: '生成时间',
          align: 'center',
          dataIndex: 'createTime',
          sorter: (a, b) => dayjs(a.createTime, 'DD-MM-YYYY HH:mm:ss').unix() - dayjs(b.createTime, 'DD-MM-YYYY HH:mm:ss').unix()
        }
      ],
      curid: {},
      url: undefined
    }
  },
  created() {

  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.getAdList()
      this.tableHeader()
      this.inviteRecord()

      if (Cookies.get('saiti_access_info') != '' && Cookies.get('saiti_access_info') != undefined && Cookies.get('saiti_access_info') != null) {
        this.saitiAccessInfo = JSON.parse(Cookies.get('saiti_access_info'))
      }
    },
    tableHeader() {
      const that = this
      that.columns[0].title = that.globalDataArray.siteTemplateLanguage.person_table_number
      that.columns[1].title = that.globalDataArray.siteTemplateLanguage.person_table_invitation_url
      that.columns[2].title = that.globalDataArray.siteTemplateLanguage.person_table_invitation_source_url
      that.columns[3].title = that.globalDataArray.siteTemplateLanguage.person_table_invitation_competition_teams
      that.columns[4].title = that.globalDataArray.siteTemplateLanguage.person_table_invitation_competition_teams_users
      that.columns[5].title = that.globalDataArray.siteTemplateLanguage.person_table_invitation_createTime
    },
    inviteRecord() {
      const that = this
      const param = 'page=' + that.paginationOpt.defaultCurrent + '&pageSize=' + that.paginationOpt.defaultPageSize
      inviteRecord(param).then(res => {
        if (res.success) {
          that.list = res.result.records
          // console.log(that.list)
          that.paginationOpt.total = res.result.total
        }
      })
    },
    getAdList() {
      const that = this
      const adParam = 'alias=person_banner'
      getAdList(adParam).then(res => {
        if (res.success) {
          that.banners = res.result[0]
        }
      })
    },

    cacelApplyFun(id) {
      // console.log(id)
      const that = this
      Modal.confirm({
        title: that.globalDataArray.siteTemplateLanguage.person_cancel_sign_up,
        content: '',
        okText: that.globalDataArray.siteTemplateLanguage.verify,
        cancelText: that.globalDataArray.siteTemplateLanguage.cancel,
        onOk() {
          const param = 'id=' + id
          cancelRecord(param).then(res => {
            if (res.success) {
              that.inviteRecord()
              message.success(res.result)
            } else {
              message.error(res.result)
            }
          })
        },
        onCancel() {
          // console.log('Cancel');
        }
      })
    },

    generateUrl() {
      const that = this
      if (!that.url) {
        message.error(that.globalDataArray.siteTemplateLanguage.anyone_competition_detail_url)
        return
      }
      generateInvitationUrl(that.url).then(res => {
        if (res.success) {
          that.inviteRecord()
          message.success(res.message)
        } else {
          message.error(res.message)
        }
      })
    }
  },
  metaInfo() {
    return {
      title: this.title,
      meta: [
        { vmid: 'description', name: 'description', content: this.description },
        { vmid: 'keywords', name: 'keywords', content: this.keywords }
      ]
    }
  }
}
</script>
<style scoped>
@import '@/assets/css/person.css';

/* 针对苹果设备的特定修复 - 只影响当前组件 */
@supports (-webkit-appearance: none) {
  /* 修复antDesignInvitation容器可能的影响 */
  .antDesignInvitation {
    /* 确保flex容器不会影响下方表格的渲染 */
    contain: layout;
  }

  /* 专门为苹果设备优化表格显示 - 使用更精确的选择器 */
  .antDesignTable :deep(.ant-table-thead > tr > th) {
    /* 确保表头有足够空间，防止文字竖向 */
    min-width: max-content;
    /* 强制水平书写模式 */
    writing-mode: horizontal-tb;
    /* 防止文字方向异常 */
    direction: ltr;
    /* 禁止文字换行 */
    white-space: nowrap;
  }
}

/* 移动端专门处理 */
@media screen and (max-width: 768px) {
  /* 调整输入框容器为垂直布局 */
  .antDesignInvitation {
    flex-direction: column !important;
    align-items: stretch;
    gap: 10px;
  }

  .antDesignInvitation :deep(.ant-input) {
    max-width: 100% !important;
  }

  .antDesignInvitation :deep(.ant-btn) {
    margin-left: 0 !important;
  }

  /* 覆盖person.css中可能导致问题的样式 - 使用scoped深度选择器 */
  .antDesignTable :deep(.ant-table-thead > tr > th) {
    /* 重置padding确保有足够空间 */
    padding: 12px 8px !important;
    /* 确保最小宽度 */
    min-width: fit-content !important;
    /* 强制水平文字 */
    writing-mode: horizontal-tb !important;
    text-orientation: mixed !important;
  }
}
</style>
